import { createContext, use } from "react";
import { LPPEditorContextType } from "./types";

export const LPPEditorContext = createContext<LPPEditorContextType | undefined>(undefined);

export const useLPPEditorContext = () => {
    const context = use(LPPEditorContext);
    if (!context) {
        throw new Error("useLPPEditorContext must be used within LPPEditorNavigator");
    }
    return context;
};
